import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, FormGroup, Checkbox } from 'react-bootstrap';
import actions from '../../redux/actions';
import Heading from '../Heading';
import NavButtons from '../NavButtons';

class PublicationSelectOtherMaterials extends Component {
  handleCheck(e, key, value) {
    const attributeValue = e.target.checked ? value : !value;
    this.props.assignAttribute(key, attributeValue);
  }

  handleNext() {
    const { fields } = this.props;

    this.props.hideAlert();
    let checked = true;

    if (fields.otherMaterial === undefined) {
      checked = false;
    }

    if (checked) {
      if (fields.otherMaterial === true) {
        this.props.router.push('/publication-reg/materials');
      } else {
        this.props.router.push('/publication-reg/authorized-agent');
      }
    } else {
      this.props.alert('error', 'Please check the required fields.');
    }
  }

  render() {
    const { fields } = this.props;

    return (
      <div className="select-work">
        <Heading text="Pre-Existing Content" />

        <div className="content">
          <Form>
            <FormGroup>
              <span className="text-red">*</span>
              <span className="sub-title">
                Do any of these scenarios apply to your registration?
              </span>

              <div className="existing-content">
                <ul>
                  <li>My registration includes a cover song.</li>
                  <li>
                    My registration includes pre-existing content that was not
                    created by the authors I listed.
                  </li>
                  <li>
                    My registration includes previously copyrighted content.
                  </li>
                </ul>
              </div>

              <Checkbox
                checked={fields.otherMaterial === true}
                onChange={(e) => this.handleCheck(e, 'otherMaterial', true)}
              >
                Yes
              </Checkbox>
              <Checkbox
                checked={fields.otherMaterial === false}
                onChange={(e) => this.handleCheck(e, 'otherMaterial', false)}
              >
                No
              </Checkbox>
            </FormGroup>
          </Form>
        </div>
        <br />
        <br />

        <div className="step-nav">
          <NavButtons
            direction="back"
            prev={() => this.props.router.goBack()}
          />
          <NavButtons direction="next" next={() => this.handleNext()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.coreg.fields,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignCoregAttribute(field, attribute));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublicationSelectOtherMaterials);



// WEBPACK FOOTER //
// src/components/Publication/PublicationSelectOtherMaterials.jsx